/** URLバリデーション */
export function isValidUrl(url: string): boolean {
  const patterns = [/^http:\/\//, /^https:\/\//];
  const filtererdPatterns = patterns.filter((pattern: RegExp) =>
    pattern.test(url)
  );
  return filtererdPatterns.length > 0;
}
